import * as React from 'react'
import { Box } from '@mui/system'
import {
  Modal,
  Typography,
  Grid,
  FormControl,
  MenuItem,
  Select
} from '@mui/material'
import { styled } from '@mui/material/styles'
import CloseIcon from '@mui/icons-material/Close'
import { AiOutlineInfoCircle } from 'react-icons/ai'
import {
  useAddTask,
  useGetJobDetailsSingleTask,
  useGetTaskData
  //   useGetTaskData
} from '../../hooks/jobcardHooks'
import * as Yup from 'yup'
// import CustomButton from '../../leastcomponent/custombutton/custombutton'
import Required from '../commoncomponents/required'
import { FieldArray, Form, Formik } from 'formik'
import CustomInput from '../../leastcomponent/custominput/input'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import CustomButton from '../../leastcomponent/custombutton/custombutton'
import DeleteIconNew from '../../assets/svg/DeleteIconNew'
import { useState } from 'react'
import { useGetMachineWiseTasks } from '../../hooks/tasktype'
import Plus from '../../assets/svg/Plus'
// import { useLocation } from 'react-router-dom'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 900,
  height: 500,
  overflow: 'auto',
  bgcolor: 'background.paper',
  borderRadius: '8px',
  boxShadow: 24,
  overFlow: 'auto',
  padding: '20px 20px 20px 20px'
}

const HeadBox = styled(Box)(() => ({
  '.btn-box': {
    display: 'flex',
    justifyContent: 'end'
  },
  '.customFormControl': {
    fontSize: '1px !important',
    fontWeight: '800'
  },
  '.customRadioGroup': {
    fontSize: '14px',
    fontWeight: '400',
    display: 'flex'
  },
  '.css-1t1j96h-MuiPaper-root-MuiDialog-paper': {
    borderRadius: '32px !important'
  },
  '.validation-error': {
    color: 'red'
  },
  '.validation-errors': {
    color: 'red',
    paddingTop: '20px !important',
    fontSize: '12px !important'
  },
  '.jobcardform': {
    // padding: '24px 0px 0px 24px',
    display: 'flex',
    justifyContent: 'end'
  },
  '.date-picker-fieldset': {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#8A8A8A'
      }
    },
    '.css-nxo287-MuiInputBase-input-MuiOutlinedInput-input': {
      padding: '9.5px !important'
    },
    '.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input': {
      padding: '9.5px 12px !important'
    },
    '.css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root': {
      borderRadius: '4px !important'
    }
  },
  '.date-picker': {
    width: '100%',
    '.css-nxo287-MuiInputBase-input-MuiOutlinedInput-input': {
      padding: '9.5px 12px'
    },
    '.css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root': {
      borderRadius: '4px'
    }
  },
  '.btn-text-transform': {
    textTransform: 'capitalize !important'
  }
}))
const Selects = styled(Select)(() => ({
  borderRadius: '4px !important',
  '.MuiOutlinedInput-input': {
    padding: '8.5px 14px',
    fontSize: '14px !important'
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#8A8A8'
  }
}))

const JobCardAddTaskById = (props) => {
  const { DetailsHandleClose, id, partId, selectedDepartment } = props
  const icon = <AiOutlineInfoCircle color="red" />
  // const { state } = useLocation()
  const selectDepartmentid = localStorage.getItem('selectDepartmentid') || selectedDepartment
  const { data: getJobDetails } = useGetJobDetailsSingleTask(id, !!id)
  const { data: getTaskData } = useGetTaskData(partId, !!partId, selectDepartmentid)
  const getTaskDataResponse = getTaskData?.data?.results
  const singleJobDetails = getJobDetails?.data
  const bompart = singleJobDetails?.bompart?.find((item) => item.id === partId)
  const finalBOMProcess = bompart?.bomprocess?.find((item) => {
    return item.department.id === selectDepartmentid
  })
  const finalBompartData = singleJobDetails?.bompart
    .map((data) => ({
      ...data,
      bomprocess: data.bomprocess.filter(
        (bomproces) => bomproces.department.id === selectDepartmentid
      )
    }))?.filter((data) => data.id === partId && data.bomprocess.length > 0)
  //   const taskArr = finalBompartData?.[0]?.bomprocess
  //     ?.map((data) => data?.task)
  //     ?.flat()
  //     ?.map((task) => {
  //       return {
  //         bomPartId: task?.bomPartId,
  //         taskNickName: task?.taskNickName,
  //         taskType: task?.taskType,
  //         description: task?.description,
  //         // taskId: task?.id
  //         id: task?.id
  //         // bomPartId: finalBompartData?.[0]?.id
  //       }
  //     })
  let initialTaskData = []
  if (getTaskDataResponse?.length > 0) {
    initialTaskData = getTaskDataResponse?.map((task) => ({
      bomPartId: task?.bomPartId,
      taskNickName: task?.taskNickName,
      taskType: task?.taskType,
      description: task?.description,
      // taskId: task?.id
      id: task?.id
    }))
  } else {
    initialTaskData = [{
      taskNickName: '',
      taskType: '',
      description: '',
      bomPartId: finalBompartData?.[0]?.id
    }]
  }
  const { mutate: addTask } = useAddTask(true)
  const { data: tasktypetData } = useGetMachineWiseTasks(selectDepartmentid)
  const [show, setShow] = useState(true)
  console.log(setShow)
  const [taskRemoveId, setTaskRemoveId] = useState([])

  //   const taskSchema = Yup.object().shape({
  //     parts: Yup.array().of(
  //       Yup.object().shape({
  //         taskNickName: Yup.string().required('Task Nick Name is required'),
  //         tasktype: Yup.string().required('Task Type is required'),
  //         description: Yup.string()
  //       })
  //     )
  //   })

  return (
    <React.Fragment>
      <Modal
        open={open}
        onClose={DetailsHandleClose}
        aria-labelledby=""
        aria-describedby="modal-modal-description"
      >
        <HeadBox sx={style}>
          <Box className="title-head-box">
            <Typography className="top-up-name">Add tasks</Typography>
            <CloseIcon className="close-icon" onClick={DetailsHandleClose} />
          </Box>
          <Box mx={'25px !important'}>
            <Grid container spacing={2} paddingTop={'5px'}>
              {/* Row 1 */}
              <Grid item xs={4} container alignItems="center">
                <Typography variant="subtitle2" color="textSecondary">
                  Job Card Name
                </Typography>
                <Typography
                  className="span-color pl-sub-text"
                  fontWeight="bold"
                >
                  {singleJobDetails?.name ? singleJobDetails?.name : '-'}
                </Typography>
              </Grid>
              <Grid item xs={4} container alignItems="center">
                <Typography variant="subtitle2" color="textSecondary">
                  Job Card Number
                </Typography>
                <Typography
                  className="span-color pl-sub-text"
                  fontWeight="bold"
                >
                  {singleJobDetails?.jobCardNumber
                    ? singleJobDetails?.jobCardNumber
                    : '-'}
                </Typography>
              </Grid>
              <Grid item xs={4} container alignItems="center">
                <Grid
                  item
                  xs={12}
                  className="align-center-with-gap"
                  sx={{ justifyContent: 'flex-start' }}
                >
                  Status:{' '}
                  {singleJobDetails?.jobCardStatus === 'approved' && (
                    <>
                      <span className="align-center">
                        <FiberManualRecordIcon
                          sx={{ fontSize: '14px', color: '#C89AFC' }}
                        />
                      </span>{' '}
                      <span className="font-size-14-with-semibold">
                        Approved
                      </span>
                    </>
                  )}
                  {singleJobDetails?.jobCardStatus === 'completed' && (
                    <>
                      <span className="align-center">
                        <FiberManualRecordIcon
                          sx={{ fontSize: '14px', color: '#1AD04C' }}
                        />
                      </span>{' '}
                      <span className="font-size-14-with-semibold">
                        Completed
                      </span>
                    </>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Box>

          <Box
            padding={'10px 24px'}
            sx={{
              borderBottom: '1px solid #dedede',
              padding: '10px 10px 20px 10px'
            }}
          ></Box>
          <Box>
            <Formik
              // key={partIndex}
              enableReinitialize={true}
              initialValues={{
                task: [initialTaskData]
                //   task: []
                // task: [
                //   [
                //     {
                //       taskNickName: '',
                //       taskType: '',
                //       description: '',
                //       bomPartId: finalBompartData?.[0]?.id
                //     }
                //   ]
                // ]
              }}
              validationSchema={Yup.object().shape({
                // task: Yup.array().of(taskSchema)
              })}
              onSubmit={(values) => {
                const flattenedTasks = values.task.flat().map((task) => ({
                  ...task,
                  jobCardId: id,
                  departmentId: selectDepartmentid,
                  bomProcessId: finalBOMProcess?.id
                }))
                addTask({
                  ...values,
                  task: flattenedTasks,
                  removedTask: taskRemoveId
                })
              }}
            >
              {({ errors, handleChange, touched, values, setFieldValue }) => (
                <React.Fragment>
                  <Form>
                    <Box>
                      {finalBompartData?.map((data, index) => {
                        let allTasks = []
                        data.bomprocess.forEach((process) => {
                          // Concatenate the tasks from each process to the allTasks array
                          allTasks = allTasks.concat(process.task)
                        })
                        return (
                          <Box
                            key={index}
                          >
                            <Grid
                              container
                              spacing={2}
                              className="padding-20-75-border-bottom"
                            >
                              <Grid item xs={4} container alignItems="center">
                                <Box className="add-task-header">Part Name</Box>
                                <Typography
                                  className="span-color pl-sub-text"
                                  fontWeight="bold"
                                >
                                  {data.partName ? data.partName : '-'}
                                </Typography>
                              </Grid>
                              <Grid item xs={4} container alignItems="center">
                                {' '}
                                <Box className="add-task-header">Part Code</Box>
                                <Typography
                                  className="span-color pl-sub-text"
                                  fontWeight="bold"
                                >
                                  {data.itemCode ? data.itemCode : '-'}
                                </Typography>
                              </Grid>
                              <Grid item xs={4} container alignItems="center">
                                {' '}
                                <Box className="add-task-header">
                                  Drawing no.
                                </Box>
                                <Typography
                                  className="span-color pl-sub-text"
                                  fontWeight="bold"
                                >
                                  {data.drawingNumber
                                    ? data.drawingNumber
                                    : '-'}
                                </Typography>
                              </Grid>
                            </Grid>
                            {show && (
                              <Box
                                className="form-child-border11"
                                style={{
                                  borderTop: '1px solid #dedede'
                                }}
                              >
                                <React.Fragment>
                                  <Box className="gap-20">
                                    <Box padding={'20px'}>
                                      <FieldArray name={`task.${index}`}>
                                        {({ push, remove }) => (
                                          <React.Fragment>
                                            <Box className="gap-20">
                                              {values?.task?.[index]?.length >
                                                0 &&
                                                values?.task?.[index]?.map(
                                                  (task, Taskindex) => (
                                                    <Box
                                                      key={Taskindex}
                                                      padding={'10px'}
                                                    >
                                                      <Grid lg={4} md={3}>
                                                        <Typography className="form-heading-1 pb-20-task">
                                                          {Taskindex + 1}
                                                          {'.'} {'Task'}
                                                        </Typography>
                                                      </Grid>
                                                      <Box
                                                        Box
                                                        borderBottom={
                                                          index ===
                                                          values?.task?.[index]
                                                            ?.length -
                                                            1
                                                            ? ''
                                                            : '1px solid #dedede'
                                                        }
                                                      >
                                                        <Typography
                                                          className="form-heading-1 pb-20-task"
                                                          display={'flex'}
                                                          justifyContent={'end'}
                                                        >
                                                          <span
                                                            onClick={() => {
                                                              remove(Taskindex)
                                                              if (task?.id) {
                                                                setTaskRemoveId(
                                                                  (prev) => [
                                                                    ...prev,
                                                                    task?.id
                                                                  ]
                                                                )
                                                              }
                                                            }}
                                                            className="process-delete"
                                                          >
                                                            <DeleteIconNew />
                                                          </span>
                                                        </Typography>
                                                        <Grid
                                                          spacing={2}
                                                          paddingBottom={'20px'}
                                                          container
                                                        >
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            md={4}
                                                            xl={4}
                                                          >
                                                            <CustomInput
                                                              label="Task Name"
                                                              placeholder="Enter Task Name"
                                                              handleChange={
                                                                handleChange
                                                              }
                                                              value={
                                                                values?.task?.[
                                                                  index
                                                                ]?.[Taskindex]
                                                                  ?.taskNickName ||
                                                                ''
                                                              }
                                                              name={`task.${index}.${Taskindex}.taskNickName`}
                                                              InputProps={{
                                                                endAdornment:
                                                                  touched
                                                                    ?.task?.[
                                                                      index
                                                                    ]?.[Taskindex]
                                                                    ?.taskNickName &&
                                                                  errors
                                                                    ?.task?.[
                                                                      index
                                                                    ]?.[Taskindex]
                                                                    ?.taskNickName &&
                                                                  icon
                                                              }}
                                                              errors={
                                                                errors?.task?.[
                                                                  index
                                                                ]?.[Taskindex]
                                                                  ?.taskNickName
                                                              }
                                                              touched={
                                                                touched?.task?.[
                                                                  index
                                                                ]?.[Taskindex]
                                                                  ?.taskNickName
                                                              }
                                                            />
                                                          </Grid>
                                                          <Grid
                                                            item
                                                            xs={4}
                                                            md={4}
                                                            lg={4}
                                                          >
                                                            <Typography className="field-title">
                                                              Task Type
                                                              <Required />
                                                            </Typography>
                                                            <FormControl
                                                              fullWidth
                                                            >
                                                              <Selects
                                                                name={`task.${index}.${Taskindex}.taskType`}
                                                                variant="outlined"
                                                                value={
                                                                  values
                                                                    ?.task?.[
                                                                      index
                                                                    ]?.[Taskindex]
                                                                    ?.taskType ||
                                                                  ''
                                                                }
                                                                onChange={(
                                                                  e
                                                                ) => {
                                                                  setFieldValue(
                                                                    `task.${index}.${Taskindex}.taskType`,
                                                                    e.target
                                                                      .value
                                                                  )
                                                                }}
                                                                displayEmpty
                                                              >
                                                                <MenuItem value="">
                                                                  <span className="menu-item-span">
                                                                    Select Task
                                                                    Type
                                                                  </span>
                                                                </MenuItem>
                                                                {tasktypetData?.data?.map(
                                                                  (
                                                                    data,
                                                                    tasktypeind
                                                                  ) => {
                                                                    return (
                                                                      <MenuItem
                                                                        value={
                                                                          data?.id
                                                                        }
                                                                        key={
                                                                          tasktypeind
                                                                        }
                                                                      >
                                                                        {
                                                                          data?.name
                                                                        }
                                                                      </MenuItem>
                                                                    )
                                                                  }
                                                                )}
                                                              </Selects>
                                                            </FormControl>
                                                            {touched.department &&
                                                              errors.department && (
                                                                <Typography className="validation-text">
                                                                  {typeof errors.department ===
                                                                  'string'
                                                                    ? errors.department
                                                                    : ''}
                                                                </Typography>
                                                            )}
                                                          </Grid>
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            md={4}
                                                            xl={4}
                                                          >
                                                            <CustomInput
                                                              label="Description"
                                                              placeholder="Enter Description"
                                                              handleChange={
                                                                handleChange
                                                              }
                                                              isRequired={false}
                                                              value={
                                                                values?.task?.[
                                                                  index
                                                                ]?.[Taskindex]
                                                                  ?.description ||
                                                                ''
                                                              }
                                                              name={`task.${index}.${Taskindex}.description`}
                                                              InputProps={{
                                                                endAdornment:
                                                                  touched
                                                                    ?.task?.[
                                                                      index
                                                                    ]?.[Taskindex]
                                                                    ?.description &&
                                                                  errors
                                                                    ?.task?.[
                                                                      index
                                                                    ]?.[Taskindex]
                                                                    ?.description &&
                                                                  icon
                                                              }}
                                                              errors={
                                                                errors?.task?.[
                                                                  index
                                                                ]?.[Taskindex]
                                                                  ?.description
                                                              }
                                                              touched={
                                                                touched?.task?.[
                                                                  index
                                                                ]?.[Taskindex]
                                                                  ?.description
                                                              }
                                                            />
                                                          </Grid>
                                                        </Grid>
                                                      </Box>
                                                    </Box>
                                                  )
                                                )}
                                            </Box>
                                            <Box padding={'20px 10px'}>
                                              <CustomButton
                                                variant="outlined"
                                                className="button-box"
                                                type="button"
                                                title="Add"
                                                endIcon={
                                                  <Plus fill={'#0160B9'} />
                                                }
                                                onClick={() =>
                                                  push({
                                                    taskNickName: '',
                                                    taskType: '',
                                                    description: '',
                                                    bomPartId: data.id
                                                  })
                                                }
                                              />
                                            </Box>
                                          </React.Fragment>
                                        )}
                                      </FieldArray>
                                    </Box>
                                  </Box>
                                </React.Fragment>
                              </Box>
                            )}
                          </Box>
                        )
                      })}
                    </Box>
                    <Box className="btn-box">
                      <CustomButton title="Submit" type="submit" />
                    </Box>
                  </Form>
                </React.Fragment>
              )}
            </Formik>
          </Box>
        </HeadBox>
      </Modal>
    </React.Fragment>
  )
}
export default JobCardAddTaskById
